import React, { useState } from 'react'
import onClickOutside from 'react-onclickoutside'
import styled from 'styled-components'

import i18n from 'live/services/i18n'

import { hasUserPermission } from '../../utils/permissions'
import { Dropdown, StyledDropdownMenu, StyledDropdownMenuItem, StyledCaret, StyledButton } from './styles'

export interface DropdownOption {
    icon: string
    description: string
    callback: () => void
}

interface IProps {
    dropdownOptions?: DropdownOption[]
    disabled?: boolean
    clickEdit?: () => void
    clickDelete?: () => void
    clickDeleteAvatar?: () => void
    avatar?: string
}
// TODO: this is not generic , how can i use that dropdown in another place? if we cant , this is not a generic.
export const AssetDropdown = ({
    disabled,
    clickDelete,
    clickEdit,
    clickDeleteAvatar,
    avatar
}: IProps): React.ReactElement => {
    const [open, setOpen] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [openDeleteAvatar, setOpenDeleteAvatar] = useState(false)

    return (
        <>
            <ProfileDropdownWithClickOutside
                open={open}
                setOpen={setOpen}
                handleClickOutside={() => setOpen(false)}
                disabled={disabled}
                click={clickDelete}
                clickEdit={clickEdit}
                openEdit={openEdit}
                setOpenEdit={setOpenEdit}
                clickDeleteAvatar={clickDeleteAvatar}
                openDeleteAvatar={openDeleteAvatar}
                setOpenDeleteAvatar={setOpenDeleteAvatar}
                avatar={avatar}
            />
        </>
    )
}

type ProfileDropdownWithClickOutsideProps = {
    open: boolean
    setOpen: (open: boolean) => void
    setShowVersionHistoryModal?: (show: boolean) => void // TODO -> study this implementation
    disabled: boolean
    click: () => void

    openEdit: boolean
    setOpenEdit: (open: boolean) => void
    clickEdit: () => void

    openDeleteAvatar: boolean
    setOpenDeleteAvatar: (open: boolean) => void
    clickDeleteAvatar: () => void
    avatar?: string
}

const ProfileDropdownWithClickOutside = onClickOutside(
    ({
        open,
        setOpen,
        disabled,
        click,
        clickEdit,
        clickDeleteAvatar,
        avatar
    }: ProfileDropdownWithClickOutsideProps) => (
        <Dropdown>
            {!hasUserPermission && (
                <ProfileDropdownButton
                    id="resourceConfigurationButton"
                    onClick={(): void => setOpen(!open)}
                    disabled={disabled}
                >
                    <i className="far fa-wrench" />
                    <StyledCaret className={`fas fa-caret-${!disabled && open ? 'up' : 'down'}`} disabled={disabled} />
                </ProfileDropdownButton>
            )}
            <ProfileDropdownMenu open={!disabled && open}>
                <ProfileDropdownMenuItem key={'Edit Avatar'} tabIndex={0} onClick={(): void => clickEdit()}>
                    <span>
                        <i className="far fa-edit" />
                    </span>
                    <div>
                        <div>
                            <OptionText>{i18n('Edit Avatar')}</OptionText>
                        </div>
                        <div className="accessOptionsLabel"></div>
                    </div>
                </ProfileDropdownMenuItem>

                <ProfileDropdownMenuItem
                    key={'Delete Avatar'}
                    tabIndex={0}
                    onClick={avatar != null && avatar.length > 0 && clickDeleteAvatar}
                    className={avatar != null && avatar.length > 0 ? '' : 'no-avatar'}
                >
                    <span>
                        <i className="far fa-user-alt-slash"></i>
                    </span>
                    <div>
                        <div>
                            <OptionText>{i18n('Delete Avatar')}</OptionText>
                        </div>
                        <div className="accessOptionsLabel"></div>
                    </div>
                </ProfileDropdownMenuItem>

                <ProfileDropdownMenuItem
                    id="resourceDeleteButton"
                    key={'Delete Resource'}
                    tabIndex={0}
                    onClick={(): void => click()}
                    style={{ color: 'red' }}
                >
                    <span>
                        <i className="far fa-trash-alt" />
                    </span>
                    <div>
                        <div>
                            <OptionText>{i18n('Delete Resource')}</OptionText>
                        </div>
                        <div className="accessOptionsLabel"></div>
                    </div>
                </ProfileDropdownMenuItem>
            </ProfileDropdownMenu>
        </Dropdown>
    )
)

const OptionText = styled.span`
    font-weight: 600;
`

const ProfileDropdownButton = styled(StyledButton)`
    font-size: 17px;
    padding-left: 0px;

    > i {
        color: ${({ theme, disabled }): string => (disabled ? theme['input-borders'] : theme['brand-primary'])};
    }
`

const ProfileDropdownMenu = styled(StyledDropdownMenu)`
    margin-top: -35px;
    margin-left: 90px;
    width: 260px;
`

const ProfileDropdownMenuItem = styled(StyledDropdownMenuItem)`
    margin-top: 20px;
    padding: 10px 20px;
    font-family: ${({ theme }): string => theme['font-semibold']};

    &.WellProfileDropdownMenuItem__delete {
        color: ${({ theme }): string => theme['brand-danger']};
    }

    .accessOptionsLabel {
        font-size: 11px;
        color: ${({ theme }): string => theme['dark-icons']};
    }

    .perspective {
        font-size: 11px;
        color: ${({ theme }): string => theme['dark-icons']};
        font-weight: 600;
    }

    > span {
        > i {
            font-size: 16px;
        }
    }

    > div {
        padding-left: 4px;
    }

    &.no-avatar {
        color: var(--gray-500);
        cursor: default;

        &:hover {
            background: transparent;
        }
    }
`
